import { Text, Box } from '@simplywallst/ui-core';

export const EmptyState = () => {
  return (
    <Box
      position="absolute"
      top="55%"
      left="50%"
      transform="translate(-50%, -50%)"
    >
      <Text
        typography="xSmall"
        color="whiteRGBA"
        opacity={0.3}
        textAlign="center"
      >
        Add all your holdings.
      </Text>
      <Text
        typography="xSmall"
        color="whiteRGBA"
        opacity={0.3}
        textAlign="center"
      >
        You&apos;ll be able to add more details in the next step.
      </Text>
    </Box>
  );
};
